<template>
  <div class="channel-advisor-modal">
    <modal
      ref="modal"
      :hide-overflow="true"
      :open="openModal"
    >
      <div
        v-if="closeBtn"
        class="channel-advisor-modal__close"
      >
        <button
          type="button"
          @click="close"
        >
          X
        </button>
      </div>
      <iframe
        :src="iframeUrl"
        tabindex="0"
      />
    </modal>
  </div>
</template>

<script>
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';
  import { eventBus } from '@Foundation/eventbus/eventbus';
  import Modal from '@Feature/Modal/code/Scripts/components/Modal/Modal.vue';

  export default {
    name: 'ChannelAdvisorModal',
    components: {
      Modal,
    },
    props: {
      closeBtn: { type: Boolean, default: false },
    },
    data() {
      return {
        openModal: false,
        iframeUrl: '',
        product: { type: Object },
      };
    },
    mounted() {
      this.$refs.modal.$on('closed', this.close);
      eventBus.$on('open-channel-advisor-modal', this.open);
      window.addEventListener('message', this.handleIframeMessage, false);
    },
    methods: {
      close() {
        this.openModal = false;
      },
      open(iframeProps) {
        if (typeof iframeProps === 'string') {
          this.iframeUrl = iframeProps;
          this.openModal = true;
          return;
        }
        const { channelAdvisorUrl, product } = iframeProps;
        this.iframeUrl = channelAdvisorUrl || '';
        this.openModal = true;
        this.product = product || {};
      },
      handleIframeMessage(message) {
        if (
          message &&
          message.data &&
          typeof message.data === 'string' &&
          message.data.startsWith('uaevent')
        ) {
          var eventArray = message.data.split('|');
          const vtoClicked = sessionStorage.getItem('vtoClicked');
          const urlParams = new URLSearchParams(window.location.search);
          const locationParams = urlParams.get('location');
          const redirectFromVto = locationParams === 'virtual-try-on';
          AnalyticsHandler.pushDataLayer({
            event: 'addToCart',
            ecommerce: eventArray[1] || 'undefined',
            eventCategory: eventArray[2] || 'ecommerce',
            eventAction: eventArray[3] || 'empty eventAction from Channel Advisor',
            eventLabel: eventArray[4] || 'empty eventLabel from Channel Advisor',
            event_name: 'add_to_cart',
            product_info: '',
            step: 'redirection',
            store_name: eventArray[3]
              ? eventArray[3].split('::')[1]
              : 'empty store name from Channel Advisor',

            products: [
              {
                name: this.product.name,
                id: this.product.id,
                price: this.product.price,
                brand: this.product.brand,
                category: this.product.category,
                variant: this.product.variant,
                quantity: 1,
                list: this.product.list,
                dimension36: this.product.dimension36,
                dimension48: this.product.dimension48,
                dimension49: vtoClicked || redirectFromVto ? 'activated' : this.product.dimension49,
                dimension91: this.product.dimension91,
              },
            ],
          });
        }
        if (
          message &&
          message.data &&
          typeof message.data === 'string' &&
          message.data.startsWith('closeevent')
        ) {
          this.close();
        }
      },
    },
  };
</script>
